import { getShop } from './index';

export const KEY_PREV_ROUTE_SI_SETTINGS = 'prev-route-si-settings';
export const KEY_PREV_ROUTE_SI_GUIDE = 'prev-route-si-guide';
export const KEY_PREV_ROUTE_SI_CODE_EDITOR = 'prev-route-si-code-editor';


export function savePrevRoute(prevRoute: string, keyStorage: string = KEY_PREV_ROUTE_SI_SETTINGS) {
  sessionStorage.setItem(`${getShop()}-${keyStorage}`, prevRoute)
}

export function getPrevRoute(keyStorage: string = KEY_PREV_ROUTE_SI_SETTINGS) {
  return sessionStorage.getItem(`${getShop()}-${keyStorage}`)
}

export function removePrevRoute(keyStorage: string = KEY_PREV_ROUTE_SI_SETTINGS) {
  sessionStorage.removeItem(`${getShop()}-${keyStorage}`)
}